import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of, retry } from 'rxjs';
import { AdvisorRepository } from '../../../domain/repositories/advisor/advisor.repository';
import { Advisor } from '../../../domain/interfaces/advisor/advisor.interface';
import { HttpClientService } from '../../services/http-client/http-client.service';
import { API_ENDPOINTS } from '../../config/api.config';

interface AdvisorDto {
  Cod: string;
  Nombre: string;
  'Nombre-cod': string;
}

interface AdvisorsListResponseDto {
  Asesores?: AdvisorDto[];
}

interface AdvisorSingularResponseDto {
  Asesor?: AdvisorDto[];
}

@Injectable()
export class AdvisorRepositoryImplementation extends AdvisorRepository {
  private readonly http = inject(HttpClientService);

  override getAdvisorByCode(code: string): Observable<Advisor | null> {
    return this.http.get<AdvisorSingularResponseDto | ''>(API_ENDPOINTS.advisors.get(code)).pipe(
      retry(1),
      map((response) => {
        const data = response.data;
        const dto = typeof data === 'object' ? data.Asesor?.[0] : undefined;
        return dto ? this.toAdvisor(dto) : null;
      }),
      catchError(() => of(null)),
    );
  }

  override getAdvisorsList(): Observable<Advisor[]> {
    return this.http.get<AdvisorsListResponseDto | ''>(API_ENDPOINTS.advisors.list).pipe(
      retry(1),
      map((response) => {
        const data = response.data;
        const list = typeof data === 'object' ? (data.Asesores ?? []) : [];
        return list.map((dto) => this.toAdvisor(dto));
      }),
      catchError(() => of([])),
    );
  }

  private toAdvisor(dto: AdvisorDto): Advisor {
    return { code: dto.Cod, name: dto.Nombre, nameCode: dto['Nombre-cod'] };
  }
}
